import { User, UserExtra, UserProfile } from '#types';

type State = {
  loading: boolean;
  extra: UserExtra;
  isLoggedIn: boolean;
  profile: UserProfile;
  user: User;
  userProfiles: UserProfile[];
  pinSettingsStatus?: 'not_configured' | 'enabled' | 'disabled';
};

export const state: State = {
  loading: false,
  extra: null,
  isLoggedIn: false,
  profile: null,
  user: null,
  userProfiles: [],
};
